/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const GET_DTW = 'MFE/CHECKOUT/GET_DTW';
export const UPDATE_DTW_OPTIONS = 'MFE/CHECKOUT/UPDATE_DTW';
export const SELECT_DTW = 'MFE/CHECKOUT/SELECT_DTW';
export const UPDATE_SELECTED_DTW = 'MFE/CHECKOUT/UPDATE_SELECTED_DTW';
export const SUBMIT_DTW = 'MFE/CHECKOUT/SUBMIT_DTW';
